module.exports = __webpack_public_path__ + "poi_texture.5e68c3759da56ecf52a29e977722c231.png";